import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBrandTerm, BackendMutationDeleteBrandTermArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteBrandTerm($id: ID!) {
    deleteBrandTerm(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteBrandTermArgs;
type Result = Pick<BackendBrandTerm, 'id'>;

export const deleteBrandTerm = async (variables: Variables): Promise<Result | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
